"use client";

/**
 * Catches errors that bubble above the root layout.
 * Shows the full error + stack so developers can debug without checking server logs.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ fontFamily: "system-ui, sans-serif", padding: "2rem", maxWidth: "60rem" }}>
        <h1 style={{ color: "#dc2626" }}>Unhandled Error</h1>
        <p style={{ fontSize: "1.125rem" }}>{error.message || "An unexpected error occurred."}</p>
        {error.digest && (
          <p style={{ color: "#6b7280", fontSize: "0.875rem" }}>Digest: {error.digest}</p>
        )}
        <pre
          style={{
            background: "#1e1e1e",
            color: "#d4d4d4",
            padding: "1rem",
            borderRadius: "0.5rem",
            overflow: "auto",
            fontSize: "0.8125rem",
            lineHeight: 1.5,
          }}
        >
          {error.stack ?? String(error)}
        </pre>
        <button
          type="button"
          onClick={reset}
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1rem",
            cursor: "pointer",
            border: "1px solid #d1d5db",
            borderRadius: "0.375rem",
            background: "#fff",
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
